import React, { useEffect, useState } from "react";
import Layout from "../Components/Layout/Layout";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationListAll,
  markNotificationRead,
} from "../Redux/Actions/NotificationActions";
import { useNavigate, useLocation } from "react-router-dom";
import { Encryptedid } from "../Utils/bcrypt";

const NotificationsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const allNotificationList = useSelector(
    (state) => state.allNotifications.notificationListAll
  );

  const [notifications, setNotifications] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");

  const searchTerm = new URLSearchParams(location.search).get("search") || "";

  const FILTERS = [
    { label: "All", value: "all" },
    { label: "Song Requests", value: "SongRequest" },
    { label: "Payments", value: "Payment" },
    { label: "Change Requests", value: "request_change" },
  ];

  const filteredNotifications = notifications.filter((n) => {
    const matchesType = activeFilter === "all" || n.notificationType === activeFilter;
    const matchesSearch = !searchTerm || n.body?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesType && matchesSearch;
  });

  useEffect(() => {
    dispatch(getNotificationListAll({ all: true }));
  }, []);


  useEffect(() => {
    if (allNotificationList && allNotificationList.length > 0) {
      setNotifications(
        allNotificationList.map((item) => ({
          ...item,
          isRead: item.isRead || false,
        }))
      );
    } else {
      setNotifications([]);
    }
  }, [allNotificationList]);

  const markAsRead = (index, id) => {
    const updatedNotifications = [...notifications];

    if (!updatedNotifications[index].isRead) {
      updatedNotifications[index].isRead = true;
      setNotifications(updatedNotifications);
      dispatch(markNotificationRead({ notificationId: id, status: true }));
    }
  };

  const markAsUnread = (index, id) => {
    const updatedNotifications = [...notifications];

    if (updatedNotifications[index].isRead) {
      updatedNotifications[index].isRead = false;
      setNotifications(updatedNotifications);
      dispatch(markNotificationRead({ notificationId: id, status: false }));
      window.location.reload();
    }

    setActiveDropdown(null);
  };

  const handleClick = (item, index) => {
    markAsRead(index, item?._id);


    if (item?.notificationType === "SongRequest") {
      navigate(
        `/events-details/${Encryptedid(item?.event)}?clientId=${item?.admin}`
      );
    }



    if (item?.notificationType === "Payment") {
      navigate("/transactions");
    }

    if (item?.notificationType === "request_change") {
      navigate("/requestchanges");
    }
  };

  const renderIcon = (type) => {
    if (type === "SongRequest") return <span style={{ fontSize: "22px" }}>🎵</span>;
    if (type === "Payment") return <span style={{ fontSize: "22px" }}>💳</span>;
    if (type === "request_change") return <span style={{ fontSize: "22px" }}>🔁</span>;
    return <span style={{ fontSize: "22px" }}>🔔</span>;
  };

  return (
    <Layout>
      <Container fluid>
        <div style={styles.pageWrapper}>
          <div style={styles.pillsRow}>
            {FILTERS.map((f) => (
              <button
                key={f.value}
                style={{
                  ...styles.pill,
                  ...(activeFilter === f.value ? styles.pillActive : {}),
                }}
                onClick={() => setActiveFilter(f.value)}
              >
                {f.label}
              </button>
            ))}
          </div>

          {filteredNotifications?.length > 0 ? (
            filteredNotifications.map((item, index) => (
              <div
                key={item._id}
                style={{
                  ...styles.notificationCard,
                  ...(item.isRead ? {} : styles.unread),
                }}
              >
                {/* LEFT CLICKABLE AREA */}
                <div
                  style={styles.clickArea}
                  onClick={() => handleClick(item, index)}
                >
                  <div style={styles.iconWrapper}>
                    {renderIcon(item?.notificationType)}
                  </div>

                  <div style={styles.contentWrapper}>
                    <p style={styles.message}>{item?.body}</p>

                    <span style={styles.time}>
                      {new Date(item?.createdAt).toLocaleString()}
                    </span>
                  </div>
                </div>

                {/* RIGHT DROPDOWN */}
                <div
                  style={styles.dropdownWrapper}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    style={styles.dotsButton}
                    onClick={() =>
                      setActiveDropdown(
                        activeDropdown === index ? null : index
                      )
                    }
                  >
                    ⋮
                  </button>

                  {activeDropdown === index && (
                    <div style={styles.dropdownMenu}>
                      <div
                        style={styles.dropdownItem}
                        onClick={() => markAsUnread(index, item?._id)}
                      >
                        Mark as Unread
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div style={styles.emptyState}>
              <p>{searchTerm ? `No notifications found for "${searchTerm}"` : "No Notifications"}</p>
            </div>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default NotificationsList;

const styles = {
  pageWrapper: {
    padding: "20px",
    maxWidth: "1200px",
    margin: "0 auto",
  },

  notificationCard: {
    display: "flex",
    alignItems: "center",
    padding: "6px",
    borderRadius: "8px",
    border: "1px solid #e6e6e6",
    marginBottom: "12px",
    transition: "0.2s",
    background: "#fff",
    position: "relative",
  },

  clickArea: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    cursor: "pointer",
  },

  unread: {
    background: "#f2f7ff",
    borderLeft: "4px solid #4a7cff",
  },

  iconWrapper: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "#f3f3f3",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "14px",
  },

  contentWrapper: {
    flex: 1,
  },

  message: {
    margin: 0,
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },

  time: {
    fontSize: "12px",
    color: "#888",
  },

  dropdownWrapper: {
    position: "relative",
  },

  dotsButton: {
    border: "none",
    background: "transparent",
    fontSize: "20px",
    cursor: "pointer",
    padding: "6px",
  },

  dropdownMenu: {
    position: "absolute",
    right: 0,
    top: "28px",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "6px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    zIndex: 10,
  },

  dropdownItem: {
    padding: "8px 14px",
    cursor: "pointer",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },

  emptyState: {
    textAlign: "center",
    padding: "40px",
    color: "#888",
  },

  pillsRow: {
    display: "flex",
    gap: "8px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },

  pill: {
    padding: "6px 16px",
    borderRadius: "20px",
    border: "1px solid #d1d0d4",
    background: "#fff",
    color: "#6e6b78",
    fontSize: "13px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.15s ease",
    cursor: "pointer",
  },

  pillActive: {
    background: "#132027",
    color: "#fff",
    border: "1px solid #132027",
  },
};